import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_quantfy.png",
      alt: "Estratégias Quantfy",
    },
    title: "Impulsione os seus rendimentos com o poder da tecnologia!",

    // String ou array de strings
    text: "Conecte-se às nossas estratégias profissionais e lucre de forma 100% automatizada.",
    testimonial: {
      text: "Geralmente, é complicado separar as emoções das decisões de compra e venda. Principalmente, após sofrer grandes variações de perdas ou ganhos. Por isso, ter uma automação possibilita que você fique livre disso e foque toda a sua atenção para o que realmente importa, o seu tempo!",
      author: {
        name: "Mauro Moura, Estrategista Quantic",
        picture:
          "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },
  stats: {
    title: "Alguns números da Quantic",
    subtitle: "Impulsionamos os seus rendimentos com o Poder da Tecnologia!",
    data: [
      {
        value: "+1K",
        description: "Clientes atendidos",
      },
      {
        value: "+10",
        description:
          "Anos de atividade na área financeira ajudando investidores a atingirem melhores resultados",
      },
      {
        value: "+8",
        description: "Anos automatizando estratégias",
      },
    ],
  },
  features: {
    type: 2,
    title: "Liberdade para sonhar e conquistar!",
    // subtitle: "Veja quais as principais vantagens dos robôs da Quantic.",
    data: [
      {
        icon: iconsSet.cloud,
        title: "Disponível a qualquer hora. Qualquer lugar.",
        description:
          "Hospedado 100% em cloud, as estratégias Quantic ficam disponíveis e prontas para você utilizar. Ligue e monitore seus robôs, mesmo quando estiver desconectado. Acesse as estratégias Quantic de qualquer dispositivo, incluindo web, telefone e tablet.",
      },
      {
        icon: iconsSet.search,
        title: "Encontre a sua oportunidade de negociação ideal.",
        description:
          "Não deixe que o medo de uma mudança no mercado o mantenha preocupado. Com tecnologia de ponta, fazemos as atualizações automaticamente. Você terá disponível um portfólio de estratégias tudo a um clique de distância.",
      },
      {
        icon: iconsSet.sparkle,
        title: "Uma forma revolucionária de negociação.",
        description:
          "A negociação automatizada é uma forma revolucionária de negociação e não está disponível para os traders de varejo há algum tempo. O motivo: pode ser bem complicado. Felizmente, facilitar a negociação automatizada é o nosso principal negócio.",
      },
      {
        icon: iconsSet.lightning,
        title: "Agilidade na operação",
        description:
          "As operações, sejam de compra ou venda, são executadas de forma bem mais rápida do que se fossem feitas manualmente pelo investidor. O Robô leva alguns milissegundos para fazer isso, sendo capaz de enviar, alterar e cancelar várias ordens ao mesmo tempo.",
      },
      // ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Quantfy.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Quantic",
    col1: [
      "A Quantic traz no time profissionais com mais de 10 anos somados em instituições financeiras.",
      "Oferece tecnologias exclusivas, treinamentos e automatização de estratégias com foco no mercado financeiro, para ajudar investidor a alcançar o suscesso em seus investimentos.",
    ],
    // col2: [
    //   "Queremos facilitar e pavimentar a boa gestão dos investimentos dos nossos clientes! Por isso, desenvolvemos alguns conceitos de robôs baseados em anos de estudos, experiência e milhares de testes positivos.",
    // ],
  },
  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos da Quantfy e veja qual se adequa melhor ao seu perfil.",
  },
  strategies: {
    title: "Estratégias Quantfy",
    heading: "Fácil. Eficiente. Inovativa.",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
